"use client";

import { cn } from "@/lib/utils";

interface ScanLinesProps {
  opacity?: number;
  className?: string;
}

export function ScanLines({ opacity = 0.03, className }: ScanLinesProps) {
  return (
    <div
      className={cn("pointer-events-none fixed inset-0 z-50 overflow-hidden", className)}
      aria-hidden="true"
    >
      {/* Horizontal scan lines */}
      <div
        className="absolute inset-0"
        style={{
          background: `repeating-linear-gradient(
            0deg,
            transparent,
            transparent 2px,
            rgba(0, 0, 0, ${opacity}) 2px,
            rgba(0, 0, 0, ${opacity}) 4px
          )`,
        }}
      />
      {/* Moving scan bar */}
      <div
        className="absolute left-0 right-0 h-[2px]"
        style={{
          background: `linear-gradient(
            90deg,
            transparent 0%,
            rgba(0, 255, 255, ${opacity * 3}) 20%,
            rgba(0, 255, 255, ${opacity * 5}) 50%,
            rgba(0, 255, 255, ${opacity * 3}) 80%,
            transparent 100%
          )`,
          animation: "scanline 8s linear infinite",
        }}
      />
    </div>
  );
}
